import React from 'react';

export const TwitterLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
  </svg>
);

export const LinkedinLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
  </svg>
);

export const FacebookLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M9 8H6v4h3v12h5V12h3.642L18 8h-4V6.333C14 5.378 14.192 5 15.115 5H18V0h-3.808C10.596 0 9 1.583 9 4.615V8z" />
  </svg>
);

export const GithubLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
  </svg>
);

export const SlackLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 17 17"
  >
    <path d="M3.655 10.841c0 .905-.738 1.644-1.643 1.644A1.647 1.647 0 01.37 10.842c0-.905.739-1.644 1.643-1.644h1.643v1.643zM4.483 10.841c0-.904.74-1.643 1.644-1.643.904 0 1.643.739 1.643 1.643v4.115c0 .904-.739 1.643-1.643 1.643a1.647 1.647 0 01-1.644-1.643V10.84zM6.127 4.242A1.647 1.647 0 014.483 2.6c0-.904.74-1.643 1.644-1.643.904 0 1.643.739 1.643 1.643v1.643H6.127zM6.127 5.07c.904 0 1.643.74 1.643 1.644 0 .904-.739 1.643-1.643 1.643H2.012A1.647 1.647 0 01.37 6.714c0-.905.739-1.643 1.643-1.643h4.115zM12.725 6.714c0-.905.739-1.643 1.643-1.643.905 0 1.644.738 1.644 1.643 0 .904-.74 1.643-1.644 1.643h-1.643V6.714zM11.897 6.714c0 .904-.739 1.643-1.643 1.643A1.647 1.647 0 018.61 6.714V2.599c0-.904.738-1.643 1.643-1.643.904 0 1.643.739 1.643 1.643v4.115zM10.254 13.312c.904 0 1.643.739 1.643 1.643 0 .905-.739 1.644-1.643 1.644a1.647 1.647 0 01-1.643-1.644v-1.643h1.643zM10.254 12.484a1.647 1.647 0 01-1.643-1.643c0-.905.739-1.643 1.643-1.643h4.114c.905 0 1.644.738 1.644 1.643 0 .904-.74 1.643-1.644 1.643h-4.114z" />
  </svg>
);

export const MediumLogo = () => (
<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M13.2811 11.6793C13.2811 14.8159 10.7557 17.3586 7.64061 17.3586C4.5255 17.3586 1.99988 14.8159 1.99988 11.6793C1.99988 8.54275 4.52531 5.99988 7.64061 5.99988C10.7559 5.99988 13.2811 8.54275 13.2811 11.6793Z"/>
<path d="M19.4693 11.6791C19.4693 14.6315 18.2066 17.0259 16.6489 17.0259C15.0912 17.0259 13.8285 14.6315 13.8285 11.6791C13.8285 8.72674 15.091 6.3324 16.6487 6.3324C18.2064 6.3324 19.4691 8.72597 19.4691 11.6791"/>
<path d="M21.9998 11.6792C21.9998 14.3238 21.5557 16.4691 21.0078 16.4691C20.46 16.4691 20.0161 14.3244 20.0161 11.6792C20.0161 9.03394 20.4601 6.88928 21.0078 6.88928C21.5556 6.88928 21.9998 9.03375 21.9998 11.6792Z"/>
</svg>

);
